var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1767929526640,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2821,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 656h544a64 64 0 0 1 64 64v80a64 64 0 0 1-64 64H256a64 64 0 0 1-64-64v-80a64 64 0 0 1 64-64z",
    fill: "#95EAFF",
    "p-id": 2822
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M831.84 608h-55.472v-48.784a79.168 79.168 0 0 0-64.368-77.712V272a16 16 0 0 0-32 0v209.92c-35.632 7.776-62.4 39.392-62.4 77.296V608H192.16A80.112 80.112 0 0 0 112 688.112v143.76A80.064 80.064 0 0 0 192.16 912h639.68A80.112 80.112 0 0 0 912 831.888v-143.76A80.064 80.064 0 0 0 831.84 608zM649.6 559.216A47.36 47.36 0 0 1 696.976 512a47.248 47.248 0 0 1 47.376 47.216V608H649.6v-48.784zM880 831.888A48.128 48.128 0 0 1 831.84 880H192.16A48.064 48.064 0 0 1 144 831.888v-143.76A48.128 48.128 0 0 1 192.16 640h639.68A48.064 48.064 0 0 1 880 688.112v143.776z",
    fill: "#0F13AE",
    "p-id": 2823
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384 485.76a16 16 0 0 0 16-16v-117.968a16 16 0 0 0-32 0v117.968a16 16 0 0 0 16 16zM288 549.968a16 16 0 0 0 16-16V416a16 16 0 0 0-32 0v117.968a16 16 0 0 0 16 16zM288 293.968a16 16 0 0 0 16-16V160a16 16 0 0 0-32 0v117.968a16 16 0 0 0 16 16zM384 197.376a16 16 0 0 0 16-16V63.408a16 16 0 0 0-32 0v117.968a16 16 0 0 0 16 16z",
    fill: "#0F13AE",
    "p-id": 2824
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M272 752m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z",
    fill: "#49A3FE",
    "p-id": 2825
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M775.52 742.16H416a16 16 0 0 0 0 32h359.52a16 16 0 0 0 0-32zM646.608 244.912a56.048 56.048 0 0 1 49.392-29.504c22.352 0 42.24 13.104 51.168 33.056a16 16 0 1 0 29.2-13.072 88 88 0 0 0-80.384-51.984 88.064 88.064 0 0 0-77.568 46.336 16 16 0 1 0 28.192 15.168z",
    fill: "#49A3FE",
    "p-id": 2826
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M830.608 192.864a149.616 149.616 0 0 0-136.736-88.416 149.776 149.776 0 0 0-131.952 78.832 16 16 0 0 0 28.176 15.184 117.792 117.792 0 0 1 103.776-62 117.648 117.648 0 0 1 107.536 69.488 16 16 0 1 0 29.2-13.088z",
    fill: "#49A3FE",
    "p-id": 2827
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M384 544m-16 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0Z",
    fill: "#49A3FE",
    "p-id": 2828
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M288 352m-16 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0Z",
    fill: "#49A3FE",
    "p-id": 2829
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M384 255.408m-16 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0Z",
    fill: "#49A3FE",
    "p-id": 2830
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon12.b3d5e84c30551e891b9cb9c999fbcd2a.svg";
export { ForwardRef as ReactComponent };